import {
  Component,
  effect,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  Signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypewriterService } from '../../service/typewriter.service';

@Component({
  selector: 'gandalf-typewriter-text',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './typewriter-text.component.html',
  styleUrl: './typewriter-text.component.scss',
})
export class TypewriterTextComponent implements OnInit, OnDestroy {
  @Input() text = '';
  @Input() speed = 20; // ms per character
  @Input() messageId = '';
  @Input() autoStart = true;
  @Output() finished = new EventEmitter<void>();
  displayText = signal<string>('');
  isTyping = signal<boolean>(false);
  tableHtml = ''; // Enthält die Tabelle
  private typewriterService = inject(TypewriterService);
  private typewriterData: {
    text: Signal<string>;
    isComplete: Signal<boolean>;
  } | null = null;

  constructor() {
    effect(() => {
      if (this.typewriterData) {
        this.displayText.set(this.typewriterData.text());
        this.isTyping.set(!this.typewriterData.isComplete());
        if (this.typewriterData.isComplete()) {
          this.finished.emit();
        }
      }
    });
  }

  ngOnInit(): void {
    if (this.text) {
      this.extractTable();
    }
    if (this.autoStart && this.text) {
      this.startTypewriter();
    }
  }

  ngOnDestroy(): void {
    if (this.messageId) {
      this.typewriterService.stopTypewriter(this.messageId);
    }
  }

  extractTable(): void {
    // extract <table> to prevent strange build up of tables
    const tableRegex = /(<table[^>]*>[\s\S]*?<\/table>)/i;
    const match = this.text.match(tableRegex);
    if (match) {
      this.tableHtml = match[1];
      this.text = this.text.replace(tableRegex, '').trim();
    } else {
      this.tableHtml = '';
    }
  }

  startTypewriter(): void {
    if (!this.text) return;

    this.isTyping.set(true);
    this.displayText.set('');

    const id = this.messageId || `typewriter-${Date.now()}`;

    this.typewriterData = this.typewriterService.typewrite(this.text, this.speed, id);
  }

  displayTextWithCursor(): string {
    let text = this.displayText();
    if (this.isTyping()) {
      text += '<span class="typewriter--cursor">|</span>';
    }
    return text;
  }
}
